import React, { useContext, useEffect, useState } from 'react';
import './WelcomeMessage.css';
import { MallContext } from '../../MallContext';
import { useLanguage } from '../../LanguageProvider';

export default function WelcomeMessage({ message, style }) {
    const { mallInfo } = useContext(MallContext);
    const { getTranslation } = useLanguage();
    const [mallTitle, setMallTitle] = useState('');

    let language = localStorage.getItem("language")

    useEffect(() => {
        if (mallInfo) setMallTitle(mallInfo.mallTitle);
    }, [mallInfo]);

    const mallName = mallTitle.replace('AVM', '').trim();
    const brand = 'Easy Point';

    const location = getTranslation('locationName', { brand, mallName });
    const greeting = getTranslation('welcomeGreeting',{brand});

    return (
        <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>

            {language === "tr" ?
                <>
                    <span style={style} className="locationName">
                        {location}
                    </span>
                    <span className="welcomeService">
                        {greeting}
                    </span>
                </>
                :
                <>
                    <span style={{ marginTop: '27px' }} className="welcomeService">
                        {greeting}
                    </span>
                    <span
                        style={{ ...style, marginTop: 0 }}
                        className="locationName"
                    >
                        {location}
                    </span>

                </>
            }


            <span className="welcomeMessage">
                {message}
            </span>
        </div>
    );
}
